// extracted by mini-css-extract-plugin
module.exports = {"hero":"WorkspaceHero_hero__ZMtsZ","titleStack":"WorkspaceHero_titleStack__MGU8o","imageError":"WorkspaceHero_imageError__XeldZ"};